/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {
  TableDefault,
  ShadowTableColumn,
  StickyTableHead,
  ArrowHolderSummary,
  ColumnContainerSummary,
} from './styles';
import {Utils} from '../../utils/api';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';

export default ({dataTableContent, dataCy}: {dataTableContent: Array<any>; dataCy?: string}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const UTILS = new Utils();
  useEffect(() => {
    useTable(dataTableContent);
  }, [dataTableContent]);

  function changeTable(e) {
    useTable([...e]);
  }
  function toggleSortString(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }
  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }
  function handleNullOrCero(data) {
    return data === null ? '-' : data;
  }

  function SortingTableHead({title = '', attr, location, sortFunction}) {
    return (
      <StickyTableHead topPosition="141px" topPositionResponsive="41px" onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickyTableHead>
    );
  }
  return (
    <TableDefault data-cy={dataCy} minWidth="1200px">
      <thead>
        <tr>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px" colSpan={5}>
            ACCOUNTABILITY
          </StickyTableHead>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px" colSpan={5}>
            LAST 7 DAYS
          </StickyTableHead>
        </tr>
        <tr>
          <SortingTableHead title="Current Streak" attr="currentstreak" location={['currentStreak']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Last 7 Days" attr="last7days" location={['last7Days']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Longest Streak" attr="longestStreak" location={['longestStreak']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Total Sessions" attr="totalsessions" location={['totalSessions']} sortFunction={toggleSortNumber} />
          <SortingTableHead
            title="Current Emphasis"
            attr="currentemphasis"
            location={['currentEmphasis']}
            sortFunction={toggleSortString}
          />
          <SortingTableHead title="Prep" attr="prep" location={['prep']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Recovery" attr="recovery" location={['recovery']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Strength" attr="strength" location={['strength']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Hybrid" attr="hybrid" location={['hybrid']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Off Days" attr="offdays" location={['offDays']} sortFunction={toggleSortNumber} />
        </tr>
      </thead>
      <tbody onClick={() => useSort('')}>
        {table?.length > 0 ? (
          table?.map((item, index) => {
            return (
              <tr key={index}>
                <td className="white">{handleNullOrCero(item?.summary?.currentStreak)}</td>
                <td className="white">{handleNullOrCero(item?.summary?.last7Days)}</td>
                <td className="white">{handleNullOrCero(item?.summary?.longestStreak)}</td>
                <td className="white">{handleNullOrCero(item?.summary?.totalSessions)}</td>
                <td className="white">{item?.summary?.currentEmphasis}</td>
                <ShadowTableColumn>{handleNullOrCero(item?.summary?.prep)}</ShadowTableColumn>
                <ShadowTableColumn>{handleNullOrCero(item?.summary?.recovery)}</ShadowTableColumn>
                <ShadowTableColumn>{handleNullOrCero(item?.summary?.strength)}</ShadowTableColumn>
                <ShadowTableColumn>{handleNullOrCero(item?.summary?.hybrid)}</ShadowTableColumn>
                <ShadowTableColumn>{handleNullOrCero(item?.summary?.offDays)}</ShadowTableColumn>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={10}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableDefault>
  );
};
